import { render, staticRenderFns } from "./CompositeRecord.vue?vue&type=template&id=194f396c&scoped=true"
import script from "./CompositeRecord.vue?vue&type=script&lang=js"
export * from "./CompositeRecord.vue?vue&type=script&lang=js"
import style0 from "./CompositeRecord.vue?vue&type=style&index=0&id=194f396c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "194f396c",
  null
  
)

export default component.exports